var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBanner),expression:"showBanner"}],staticClass:"banner-section"},[_c('img',{staticClass:"dealer-banner",attrs:{"src":_vm.dealerBanner,"alt":"dealer_banner"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }